import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {DraftJobChanges} from "../../../models/draft-job-changes.model";
import {DraftJobChangeAvailability} from "../../../types/draft-job-change-availability.enum";
import {DraftJobChangeStatus} from "../../../types/draft-job-change-status.enum";
import {DraftJobChangeReason} from "../../../types/draft-job-change-reason.enum";

const RECOVERABLE_REASONS: { [reason: string]: string } = {
  [DraftJobChangeReason.DISPATCHED_ROUTE_EDITS_DISABLED]: 'PLANNING_DRAFT_JOB_CHANGES_RECOVER_DISPATCHED_ROUTE',
  // Not a guard to clear — apply's rescan found nothing left to write. A fresh scan will drop
  // this row entirely rather than leave it FAILED.
  [DraftJobChangeReason.NOTHING_TO_SYNC]: 'PLANNING_DRAFT_JOB_CHANGES_RECOVER_NOTHING_TO_SYNC'
};

require('./planning-draft-job-change-row.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-job-change-row',
  templateUrl: './planning-draft-job-change-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobChangeRowComponent {
  @Input() change: DraftJobChanges;
  @Input() isSelected: boolean;
  @Input() isExpanded: boolean;
  // True while the list is in "all matching changes are selected" mode — per-row toggling is
  // disabled then, since the server doesn't support excluding individual ids from a filter-based
  // apply/dismiss; the user must clear the bulk selection first.
  @Input() isSelectionLocked: boolean;
  @Output() onToggleSelect = new EventEmitter<DraftJobChanges>();
  @Output() onToggleExpand = new EventEmitter<DraftJobChanges>();

  public readonly statuses = DraftJobChangeStatus;

  get isUnavailable(): boolean {
    return this.change?.availability === DraftJobChangeAvailability.UNAVAILABLE;
  }

  get recoveryHintKey(): string {
    return RECOVERABLE_REASONS[this.change?.failureReason] || null;
  }

  toggleSelect(): void {
    if (this.isUnavailable || this.isSelectionLocked) {
      return;
    }
    this.onToggleSelect.emit(this.change);
  }

  toggleExpand(): void {
    this.onToggleExpand.emit(this.change);
  }
}
